
export default {
  support: {
    doc: '帮助文档',
    manual: '使用手册',
    client: 'AI 客户端',
    error: '常见错误',
    popupError: '弹窗错误',
    win7Error: 'win7安装之后客户端报错',
  },
}
